export default () => {

  $('a[href^="#"]:not([href="#"])').on('click', (e) => {
    e.preventDefault();

    $('html, body').stop().animate({
      'scrollTop': $(e.currentTarget.hash).offset().top
    }, 350, 'swing', function() {
      window.location.hash = e.currentTarget.hash;
    });
  });

};
